<template>
  <v-container fluid grid-list-xl v-if="customer">
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-btn fab fixed bottom right large color="primary" @click="showModal">
          <v-icon>edit</v-icon>
        </v-btn>

        <v-btn small to="/customers">Back to Customers</v-btn>

        <v-layout row wrap>
          <v-flex xs12>
          <v-card>
            <v-card-title>
              <h4>{{ customer.firstName }} {{ customer.lastName }}</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>Phone:</v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    <a :href="`tel:${ customer.phone }`">{{ customer.phone }}</a>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Address:</v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    <a target="_blank" :href="`https://maps.google.com/?q=${ customer.address.address }, ${ customer.address.city } ${ customer.address.state } ${ customer.address.postcode }`">{{ customer.address.address }}<br>{{ customer.address.city }} {{ customer.address.state }} {{ customer.address.postcode }}</a>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Email:</v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    <a :href="`${ customer.email }`">{{ customer.email }}</a>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
          </v-flex>
        </v-layout> <!-- Customer Details -->

        <v-layout v-if="events">
          <h2>Timeline</h2>
        </v-layout> <!-- Timeline -->

        <v-card v-if="orders">
          <v-card-title>
            <h4>Past Orders</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12>
                <v-list dense>
                  <v-list-tile v-for="(order, index) in orders" :key="index">
                    <v-list-tile-content>{{ order.orderCode }}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <v-btn class="primary" small :to="`/order/${ order._id }`">Details</v-btn>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card> <!-- Past Orders and Free Samples -->

        <v-dialog v-model="isModalVisible">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>Edit Customer</v-card-title>
            <v-card-text>
              <h3 class="headline">Customer Details</h3>
              <v-text-field v-model="customer.firstName" label="First Name"></v-text-field>
              <v-text-field v-model="customer.lastName" label="Last Name"></v-text-field>
              <v-text-field v-model="customer.email" label="Email"></v-text-field>
              <v-text-field v-model="customer.phone" label="Phone"></v-text-field>
              <v-checkbox type="checkbox" v-model="customer.newsletter" label="Newsletter?" color="primary"></v-checkbox>
              <h3 class="headline">Address</h3>
              <v-text-field v-model="customer.address.address" label="Address"></v-text-field>
              <v-text-field v-model="customer.address.city" label="Suburb"></v-text-field>
              <v-text-field v-model="customer.address.state" label="State"></v-text-field>
              <v-text-field v-model="customer.address.postcode" label="Postcode"></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary " @click="saveCustomer()">Save Customer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerService from '@/services/CustomerService'
export default {
  name: 'EditCustomer',
  data () {
    return {
      customer: null,
      orders: null,
      events: null,
      isModalVisible: false
    }
  },
  mounted () {
    this.getCustomer()
  },
  methods: {
    async getCustomer () {
      const response = await CustomerService.getCustomer(this.$route.params.id)

      this.customer = response.data.customer

      if (!this.customer.address) {
        this.customer.address = {
          address: '',
          city: '',
          state: '',
          postcode: ''
        }
      }

      this.getOrders()
    },

    async getOrders () {
      const response = await CustomerService.getOrders(this.$route.params.id)
      this.orders = response.data.orders
    },

    async updateCustomer () {
      // Need to save the address, then replace the address with a reference to the address object.

      this.customer.address.customerID = this.customer._id
      await CustomerService.updateAddress({
        address: this.customer.address
      })

      this.customer.address = this.customer.address._id

      await CustomerService.updateCustomer({
        customer: this.customer
      })

      this.getCustomer()
    },

    saveCustomer () {
      this.updateCustomer()
      this.closeModal()
    },

    showModal () {
      this.isModalVisible = true
    },

    closeModal () {
      this.isModalVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customers/Customer.vue